import styled from 'styled-components';
import ArrowRightSVG from './arrow-right.svg';

const NewArrowRightIcon = styled(
  ArrowRightSVG as React.SFC<React.SVGProps<SVGSVGElement>>,
)`
  width: ${props => props.width || '2.4rem'};
  height: ${props => props.height || '2.4rem'};
  fill: ${props => props.fill || props.theme.colors.goBrandBlue.base};
`;

export default NewArrowRightIcon;